<template>
  <fieldset class="bs3-margin-top30" ref="projectTemplateTaskRuleSectionRef">
    <legend>
      <i class="fa-light fa-tasks"></i>
      <span class="bs3-margin-left3">{{ 'dictionary.project.template.task.rule.plural' | i18nText(pDictionary) }}</span>
      <a class="btn btn-default btn-sm bs3-margin-left bs3-margin-bottom1" @click.prevent="addTaskRule">
        <i class="fa-light fa-plus"></i> <span class="bs3-margin-left3">{{ 'dictionary.actions.add' | i18nText(pDictionary) }}</span>
      </a>
    </legend>
    <div class="table-responsive">
      <table class="table table-sm table-condensed table-striped table-hover">
        <thead>
        <tr>
          <th class="minWidthCell"></th>
          <th class="minWidthCell">{{ 'dictionary.actions' | i18nText(pDictionary) }}</th>
          <th class="min300WidthCell"><span class="required">*</span> {{ 'dictionary.project.type.task' | i18nText(pDictionary) }}</th>
          <th class="min300WidthCell">{{ 'dictionary.project.specification.info' | i18nText(pDictionary) }}</th>
          <th class="minWidthCell text-center">{{ 'dictionary.project.template.task.rule.date.production.offset' | i18nText(pDictionary) }}
            <i class="fa-light fa-circle-question" aria-hidden="true" data-toggle="tooltip" data-container="body" data-placement="top"
                :title="pDictionary['dictionary.project.template.task.rule.date.production.offset.hint']"></i></th>
          <th class="minWidthCell text-center">{{ 'dictionary.project.template.task.rule.duration' | i18nText(pDictionary) }} <i
              class="fa-light fa-circle-question" aria-hidden="true" data-toggle="tooltip" data-container="body" data-placement="top"
              :title="pDictionary['dictionary.project.template.task.rule.duration.hint']"></i></th>
          <th class="minWidthCell">{{ 'dictionary.project.priority' | i18nText(pDictionary) }}</th>
          <th>{{ 'dictionary.project.template.task.rule.role.assignments.rules' | i18nText(pDictionary)}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="taskRules.length === 0">
          <td class="text-center" :colspan="nbOfCols"><span
              class="emptyOrNull">{{ pDictionary['dictionary.general.none'] }}</span></td>
        </tr>
        <project-template-save-form-task-rule
            v-for="(taskRule, index) in taskRules"
            :key="vForIdKey(taskRule)"
            :p-index="index"
            :p-dictionary="pDictionary"
            :p-currencies="pCurrencies"
            :p-language="pLanguage"
            :p-task-rule="taskRule"
            :p-error-list="pErrorList"
            :p-user-refs-by-role-id="userRefsByRoleId"
            :p-input-prefix="'dataForm.data.taskRules[' + index + '].'"
            :p-class-prefix="'dataForm_data_taskRules' + index + '_'"
            @copy-task-rule="onCopyTask"
            @remove-task-rule="onRemoveTask">
        </project-template-save-form-task-rule>
        </tbody>
      </table>
    </div>
  </fieldset>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import ProjectTemplateSaveFormTaskRule from "@/components/modules/production-module/project-template/form-save/ProjectTemplateSaveFormTaskRule";

export default {
  name: "ProjectTemplateSaveFormTaskRuleSection",
  components: {ProjectTemplateSaveFormTaskRule},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pTaskRules: Array
  },
  data: function () {
    return {
      taskRules: this.pTaskRules,
      userRefsByRoleId: {}
    }
  },
  methods: {
    addTaskRule()
    {
      this.$emit('add-task-rule');
    },
    onCopyTask(taskRule)
    {
      this.$emit('copy-task-rule', taskRule);
    },
    onRemoveTask(taskRule)
    {
      this.$emit('remove-task-rule', taskRule);
    },
    loadUserRefsByRoleId()
    {
      let _component = this;
      $.ajax({
               type: "POST",
               url: '/mediaplan/app/endpoints/json-api/ref/roles/users',
               data: JSON.stringify({}),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (list) {
        _component.userRefsByRoleId = list;
      });
    }
  },
  computed: {
    nbOfCols: function () {
      return 8;
    }
  },
  mounted()
  {
    let _component = this;

    _component.loadUserRefsByRoleId();

    _component.$nextTick(function () {
      let $projectTemplateTaskRuleSectionRef = $(this.$refs.projectTemplateTaskRuleSectionRef);
      $projectTemplateTaskRuleSectionRef.find('[data-toggle="tooltip"]').tooltip({container: 'body', sanitize: false});
    });
  },
  destroyed()
  {
    let $projectTemplateTaskRuleSectionRef = $(this.$refs.projectTemplateTaskRuleSectionRef);
    $projectTemplateTaskRuleSectionRef.find('[data-toggle="tooltip"]').tooltip('destroy');
  }
}
</script>

<style scoped>

</style>